// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_secret.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { Any } from "../../../../google/protobuf/any";
import { AppUserRef } from "./app_user";
/**
 * @generated from protobuf message c1.api.app.v1.AppSecretExpandMask
 */
export interface AppSecretExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppSecretRef
 */
export interface AppSecretRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_resource_type_id = 3
     */
    appResourceTypeId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppSecretsWithAlertCountRequest
 */
export interface SearchAppSecretsWithAlertCountRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * @generated from protobuf field: string app_id = 4
     */
    appId: string;
    /**
     * @generated from protobuf field: repeated string resource_type_ids = 5
     */
    resourceTypeIds: string[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppSecretRef refs = 6
     */
    refs: AppSecretRef[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserRef identity_app_user_refs = 7
     */
    identityAppUserRefs: AppUserRef[];
    /**
     * @generated from protobuf field: c1.api.app.v1.AppSecretExpandMask expand_mask = 8
     */
    expandMask?: AppSecretExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppSecretsWithAlertCountResponse
 */
export interface SearchAppSecretsWithAlertCountResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppSecretResourceView list = 1
     */
    list: AppSecretResourceView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppSecretResourceView
 */
export interface AppSecretResourceView {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppSecretResource app_secret = 1
     */
    appSecret?: AppSecretResource;
    /**
     * @generated from protobuf field: int32 alert_count = 2
     */
    alertCount: number;
    /**
     * @generated from protobuf field: string app_path = 3
     */
    appPath: string;
    /**
     * @generated from protobuf field: string resource_type_path = 4
     */
    resourceTypePath: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppSecretResource
 */
export interface AppSecretResource {
    /**
     * The app that this secret belongs to.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The secret type that this secret is.
     *
     * @generated from protobuf field: string app_resource_type_id = 2
     */
    appResourceTypeId: string;
    /**
     * The id of the secret.
     *
     * @generated from protobuf field: string id = 3
     */
    id: string;
    /**
     * The datetime, in RFC3339 format, of when the AppSecret was discovered in ConductorOne.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4
     */
    createdAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the AppSecret was last updated in ConductorOne.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5
     */
    updatedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the AppSecret was deleted in ConductorOne.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 6
     */
    deletedAt?: Timestamp;
    /**
     * The display name for this secret.
     *
     * @generated from protobuf field: string display_name = 7
     */
    displayName: string;
    /**
     * The ID of the user that is associated with the AppSecret.
     *
     * @generated from protobuf field: string identity_app_user_id = 8
     */
    identityAppUserId: string;
    /**
     * The datetime, in RFC3339 format, of when the AppSecret expires.
     *
     * @generated from protobuf field: google.protobuf.Timestamp secret_expires_at = 9
     */
    secretExpiresAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the AppSecret was last used or updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp last_used_at = 10
     */
    lastUsedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the AppSecret was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp secret_created_at = 11
     */
    secretCreatedAt?: Timestamp;
}
// @generated message type with reflection information, may provide speed optimized methods
class AppSecretExpandMask$Type extends MessageType<AppSecretExpandMask> {
    constructor() {
        super("c1.api.app.v1.AppSecretExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "app_id", "app_resource_type_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<AppSecretExpandMask>): AppSecretExpandMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<AppSecretExpandMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppSecretExpandMask): AppSecretExpandMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppSecretExpandMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppSecretExpandMask
 */
export const AppSecretExpandMask = new AppSecretExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppSecretRef$Type extends MessageType<AppSecretRef> {
    constructor() {
        super("c1.api.app.v1.AppSecretRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "app_resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<AppSecretRef>): AppSecretRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.appId = "";
        message.appResourceTypeId = "";
        if (value !== undefined)
            reflectionMergePartial<AppSecretRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppSecretRef): AppSecretRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string app_resource_type_id */ 3:
                    message.appResourceTypeId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppSecretRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string app_resource_type_id = 3; */
        if (message.appResourceTypeId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appResourceTypeId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppSecretRef
 */
export const AppSecretRef = new AppSecretRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppSecretsWithAlertCountRequest$Type extends MessageType<SearchAppSecretsWithAlertCountRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppSecretsWithAlertCountRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppSecretRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 7, name: "identity_app_user_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 8, name: "expand_mask", kind: "message", T: () => AppSecretExpandMask }
        ]);
    }
    create(value?: PartialMessage<SearchAppSecretsWithAlertCountRequest>): SearchAppSecretsWithAlertCountRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.appId = "";
        message.resourceTypeIds = [];
        message.refs = [];
        message.identityAppUserRefs = [];
        if (value !== undefined)
            reflectionMergePartial<SearchAppSecretsWithAlertCountRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppSecretsWithAlertCountRequest): SearchAppSecretsWithAlertCountRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* string app_id */ 4:
                    message.appId = reader.string();
                    break;
                case /* repeated string resource_type_ids */ 5:
                    message.resourceTypeIds.push(reader.string());
                    break;
                case /* repeated c1.api.app.v1.AppSecretRef refs */ 6:
                    message.refs.push(AppSecretRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.app.v1.AppUserRef identity_app_user_refs */ 7:
                    message.identityAppUserRefs.push(AppUserRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* c1.api.app.v1.AppSecretExpandMask expand_mask */ 8:
                    message.expandMask = AppSecretExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppSecretsWithAlertCountRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* string app_id = 4; */
        if (message.appId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appId);
        /* repeated string resource_type_ids = 5; */
        for (let i = 0; i < message.resourceTypeIds.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.resourceTypeIds[i]);
        /* repeated c1.api.app.v1.AppSecretRef refs = 6; */
        for (let i = 0; i < message.refs.length; i++)
            AppSecretRef.internalBinaryWrite(message.refs[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.app.v1.AppUserRef identity_app_user_refs = 7; */
        for (let i = 0; i < message.identityAppUserRefs.length; i++)
            AppUserRef.internalBinaryWrite(message.identityAppUserRefs[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppSecretExpandMask expand_mask = 8; */
        if (message.expandMask)
            AppSecretExpandMask.internalBinaryWrite(message.expandMask, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppSecretsWithAlertCountRequest
 */
export const SearchAppSecretsWithAlertCountRequest = new SearchAppSecretsWithAlertCountRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppSecretsWithAlertCountResponse$Type extends MessageType<SearchAppSecretsWithAlertCountResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppSecretsWithAlertCountResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppSecretResourceView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchAppSecretsWithAlertCountResponse>): SearchAppSecretsWithAlertCountResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchAppSecretsWithAlertCountResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppSecretsWithAlertCountResponse): SearchAppSecretsWithAlertCountResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppSecretResourceView list */ 1:
                    message.list.push(AppSecretResourceView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppSecretsWithAlertCountResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppSecretResourceView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppSecretResourceView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppSecretsWithAlertCountResponse
 */
export const SearchAppSecretsWithAlertCountResponse = new SearchAppSecretsWithAlertCountResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppSecretResourceView$Type extends MessageType<AppSecretResourceView> {
    constructor() {
        super("c1.api.app.v1.AppSecretResourceView", [
            { no: 1, name: "app_secret", kind: "message", T: () => AppSecretResource },
            { no: 2, name: "alert_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "resource_type_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AppSecretResourceView>): AppSecretResourceView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.alertCount = 0;
        message.appPath = "";
        message.resourceTypePath = "";
        if (value !== undefined)
            reflectionMergePartial<AppSecretResourceView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppSecretResourceView): AppSecretResourceView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppSecretResource app_secret */ 1:
                    message.appSecret = AppSecretResource.internalBinaryRead(reader, reader.uint32(), options, message.appSecret);
                    break;
                case /* int32 alert_count */ 2:
                    message.alertCount = reader.int32();
                    break;
                case /* string app_path */ 3:
                    message.appPath = reader.string();
                    break;
                case /* string resource_type_path */ 4:
                    message.resourceTypePath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppSecretResourceView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppSecretResource app_secret = 1; */
        if (message.appSecret)
            AppSecretResource.internalBinaryWrite(message.appSecret, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 alert_count = 2; */
        if (message.alertCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.alertCount);
        /* string app_path = 3; */
        if (message.appPath !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appPath);
        /* string resource_type_path = 4; */
        if (message.resourceTypePath !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.resourceTypePath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppSecretResourceView
 */
export const AppSecretResourceView = new AppSecretResourceView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppSecretResource$Type extends MessageType<AppSecretResource> {
    constructor() {
        super("c1.api.app.v1.AppSecretResource", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "512" } } } },
            { no: 8, name: "identity_app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "secret_expires_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 10, name: "last_used_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 11, name: "secret_created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<AppSecretResource>): AppSecretResource {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appResourceTypeId = "";
        message.id = "";
        message.displayName = "";
        message.identityAppUserId = "";
        if (value !== undefined)
            reflectionMergePartial<AppSecretResource>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppSecretResource): AppSecretResource {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_resource_type_id */ 2:
                    message.appResourceTypeId = reader.string();
                    break;
                case /* string id */ 3:
                    message.id = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 4:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 5:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 6:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* string display_name */ 7:
                    message.displayName = reader.string();
                    break;
                case /* string identity_app_user_id */ 8:
                    message.identityAppUserId = reader.string();
                    break;
                case /* google.protobuf.Timestamp secret_expires_at */ 9:
                    message.secretExpiresAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.secretExpiresAt);
                    break;
                case /* google.protobuf.Timestamp last_used_at */ 10:
                    message.lastUsedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastUsedAt);
                    break;
                case /* google.protobuf.Timestamp secret_created_at */ 11:
                    message.secretCreatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.secretCreatedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppSecretResource, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_resource_type_id = 2; */
        if (message.appResourceTypeId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appResourceTypeId);
        /* string id = 3; */
        if (message.id !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.id);
        /* google.protobuf.Timestamp created_at = 4; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 5; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 6; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string display_name = 7; */
        if (message.displayName !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.displayName);
        /* string identity_app_user_id = 8; */
        if (message.identityAppUserId !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.identityAppUserId);
        /* google.protobuf.Timestamp secret_expires_at = 9; */
        if (message.secretExpiresAt)
            Timestamp.internalBinaryWrite(message.secretExpiresAt, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp last_used_at = 10; */
        if (message.lastUsedAt)
            Timestamp.internalBinaryWrite(message.lastUsedAt, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp secret_created_at = 11; */
        if (message.secretCreatedAt)
            Timestamp.internalBinaryWrite(message.secretCreatedAt, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppSecretResource
 */
export const AppSecretResource = new AppSecretResource$Type();
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppSecretSearch
 */
export const AppSecretSearch = new ServiceType("c1.api.app.v1.AppSecretSearch", [
    { name: "SearchAppSecretsWithAlertCount", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppSecretsWithAlertCountRequest, O: SearchAppSecretsWithAlertCountResponse }
]);
